import React from "react";
import moment from 'moment';
import Constants from '../utils/Constants'
const googleApiKey = "AIzaSyCPbmxHXnF0DbOltt1xfRZSIJ6hKSpHZvE";
const expandedLine = 3;
const fetchSize = {
  comments: 5
};
function objLength(obj) {
  if (obj !== undefined && obj !== null) return Object.keys(obj).length;
  return 0;
}
function fileSizesObj(){
  const filesSizes = {
    companyLogo: 200,
    companyCover: 1*1024,
    companyFounder: 500,
    companyTeam: 500,
    userProfile: 200,
    userCover: 1*1024,
    postImage: 1*1024,
    postVideo: 5*1024,
  };
  return filesSizes
}
function secondsToTime(secs) {
  var hours = Math.floor(secs / (60 * 60));
  var divisor_for_minutes = secs % (60 * 60);
  var minutes = Math.floor(divisor_for_minutes / 60);

  var divisor_for_seconds = divisor_for_minutes % 60;
  var seconds = Math.ceil(divisor_for_seconds);
  var obj = {
    h: hours < 10 ? "0" + hours : hours,
    m: minutes < 10 ? "0" + minutes : minutes,
    s: seconds < 10 ? "0" + seconds : seconds
  };
  return obj;
}
function convertDate(date,format='MM-DD-YYYY'){
  return moment(date).format(format)
}
function getCurrentTS(){
  return Date.now();
}
function getDateObj(createdTs) {
    const date = (createdTs!==undefined) ? new Date( createdTs *1000) : new Date();
    const mL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const mS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    const weekDaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const weekDaysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const hours12 = [];
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const data = {
      fullYear: date.getFullYear(),
      monthNum: date.getMonth(),
      dayNum: date.getDate(),
      monthFull: mL[date.getMonth()],
      monthShort: mS[date.getMonth()],
      weekNum: date.getDay(),
      weekFull: weekDaysFull[date.getDay()],
      weekShort: weekDaysShort[date.getDay()],
      hours24: date.getHours(),
      hours12: hours % 12,
      ampm: hours >= 12 ? 'pm' : 'am',
      minutes: minutes < 10 ? '0'+minutes : minutes,
      seconds: date.getSeconds(),
    };
    return data;
}

function timeSince(createdTs) {
  const date = new Date( createdTs *1000);

  const seconds = Math.floor((new Date() - date) / 1000);

  const totalDays = Math.floor(seconds / 86400);

  const numYear = Math.floor(totalDays / 365); 
  if(numYear>0){
    return numYear+ ' year(s)';
  } 

  const numMonth = Math.floor(totalDays / 30);
  if(numMonth>0){
    const days = Math.floor((totalDays % 365) % 30);
    if(days>0){
      //return numMonth+ ' months ' + days+ 'days';
    }
    return numMonth+ ' month(s) ago';
  }

  const numWeek = Math.floor((totalDays % 365) / 7);  
  if(numWeek>0){
    const days = Math.floor((totalDays % 365) % 7);
    if(days>0){
      //return numWeek+ ' weeks ' + days+ 'days';
    }
    return numWeek+ ' week(s) ago';
  }

  const numDays = Math.floor(seconds / (24*60*60)); 
  if(numDays>0){
    return numDays+ ' day(s) ago';
  }
  
  const numHours = Math.floor(seconds / (60*60));
  if(numHours>0){
    return numHours+ ' hr(s) ago';
  }

  const numMins = Math.floor(seconds / 60);
  if(numMins>0){
    return numMins+ ' min(s) ago';
  }
  
  const sec = (seconds>0) ? seconds : 1;
  return sec+ ' sec';
 /* var interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    return interval + " years";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval >= 1) {
    return interval + " months";
  }
  interval = Math.floor(seconds / 86400);
  if (interval >= 1) {
    return interval + " days";
  }
  interval = Math.floor(seconds / 3600);
 
  if (interval > 1  && interval <=24) {
    return interval + " hours";
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " min";
  }
*/


  return Math.floor(seconds) + " seconds";
}
function flashMsg(key) {
  const msgList = {
    requireFields: "Please fill all the required fields.",
    apiResErr: "There is some techinical error. Please try again.",
    otpRequiredErr: "Please enter the OTP",
    signupSuccess: "Signup successfully.",
    loginSuccess: "You have been login successfully.",
    companyCreateSuccess: "",
    addressSaveSuccess: "Address saved successfully",
    companyCreateFailed: "An error occurred while creating the company. Please try again.",
    company_name_req: "Company name is required",
    company_email_req: "Company email is required",
    company_sub_title_req: "Company sub-title is required",
    company_type_req: "Company type is required",
    company_description_req: "Company description is required",
    company_size_req: "Company size is required",
    company_industry_req: "Company industry is required",
    company_address_req: "Company address is required",
    company_country_req: "Company country is required",
    company_state_req: "Company state is required",
    company_city_req: "Company city is required",
    company_zipcode_req: "Company zipcode is required",
    emailReq: "Email is required",
    emailNotValid: "Please enter valid email address",
    otpLength: "OTP allow only six digit",
    passReq: "Password is required",
    passShort: "Password is too short",
    company_iagree_req: "You should have to checked T&C",


    invalidParams: "Invalid request params"
  };
  return msgList[key];
}

function chkVal(val, isVal = "undefined") {
  if (isVal === "undefined") return val === undefined ? "" : val;
  else if (isVal === "null") return val === null ? "" : val;
  else if (isVal === "blank") return val === "" ? "" : val;
  return "";
}
function getDropdownsVals(list) {
  let listObj = [];
  if (list === "PostPrivacy") {
    listObj = [
      { id: 1, name: "PUBLIC", value:"PUBLIC" },
      { id: 2, name: "PRIVATE", value:"ONLY_ME" },
      { id: 3, name: "CONNECTIONS", value:"NETWORK" },
    ];
  } else if (list === "CompanyTypes") {
    listObj = [
      { id: 1, name: "Agency" },
      { id: 2, name: "Government" },
      { id: 3, name: "Nonprofit" },
      { id: 4, name: "Partnership" },
      { id: 5, name: "Private" },
      { id: 6, name: "Public" },
      { id: 7, name: "Self-Employed" },
      { id: 8, name: "Sole Propertiership" }
    ];
  } else if (list === "CompanyIndustries") {
    listObj = [
      { id: 1, name: "Accounting/Finance" }, { id: 2, name: "Advertising/PR/MR/Events" }, { id: 3, name: "Agriculture/Dairy" }, { id: 4, name: "Animation" }, { id: 5, name: "Architecture/Interior Designing" }, { id: 6, name: "Auto/Auto Ancillary" }, { id: 7, name: "Aviation / Aerospace Firms" }, { id: 8, name: "Banking/Financial Services/Broking" }, { id: 9, name: "BPO/ITES" }, { id: 10, name: "Brewery / Distillery" }, { id: 11, name: "Broadcasting" }, { id: 12, name: "Ceramics /Sanitary ware" }, { id: 13, name: "Chemicals/PetroChemical/Plastic/Rubber" }, { id: 14, name: "Construction/Engineering/Cement/Metals" }, { id: 15, name: "Consumer Durables" }, { id: 16, name: "Courier/Transportation/Freight" }, { id: 17, name: "Defence/Government" }, { id: 18, name: "Education/Teaching/Training" }, { id: 19, name: "Electricals / Switchgears" }, { id: 20, name: "Export/Import" }, { id: 21, name: "Facility Management" }, { id: 22, name: "Fertilizers/Pesticides" }, { id: 23, name: "FMCG/Foods/Beverage" }, { id: 24, name: "Food Processing" }, { id: 25, name: "Fresher/Trainee" }, { id: 26, name: "Gems & Jewellery" }, { id: 27, name: "Glass" }, { id: 28, name: "Heat Ventilation Air Conditioning" }, { id: 29, name: "Hotels/Restaurants/Airlines/Travel" }, { id: 30, name: "Industrial Products/Heavy Machinery" }, { id: 31, name: "Insurance" }, { id: 32, name: "Internet/Ecommerce" }, { id: 33, name: "IT-Hardware & Networking" }, { id: 34, name: "IT-Software/Software Services" }, { id: 35, name: "KPO / Research /Analytics" }, { id: 36, name: "Leather" }, { id: 37, name: "Legal" }, { id: 38, name: "Media/Dotcom/Entertainment" }, { id: 39, name: "Medical/Healthcare/Hospital" }, { id: 40, name: "Medical Devices / Equipments" }, { id: 41, name: "Mining" }, { id: 42, name: "NGO/Social Services" }, { id: 43, name: "Office Equipment/Automation" }, { id: 44, name: "Oil and Gas/Power/Infrastructure/Energ" }, { id: 45, name: "Paper" }, { id: 46, name: "Pharma/Biotech/Clinical Research" }, { id: 47, name: "Printing/Packaging" }, { id: 48, name: "Publishing" }, { id: 49, name: "Real Estate/Property" }, { id: 50, name: "Recruitment" }, { id: 51, name: "Retail" }, { id: 52, name: "Security/Law Enforcement" }, { id: 53, name: "Semiconductors/Electronics" }, { id: 54, name: "Shipping/Marine" }, { id: 55, name: "Steel" }, { id: 56, name: "Strategy /Management Consulting Firms" }, { id: 57, name: "Sugar" }, { id: 58, name: "Telcom/ISP" }, { id: 59, name: "Textiles/Garments/Accessories" }, { id: 60, name: "Tyres" }, { id: 61, name: "Water Treatment / Waste Management" }, { id: 62, name: "Wellness / Fitness / Sports / Beauty" }, { id: 63, name: "Other" },
    ];
  } else if (list === "CompanyBannerTabs") {
    listObj = [
      { id: 7, tab: 'Suggested Companies', url:'connection-suggested-companies' },{ id: 1, tab: 'About', url:'about' }, { id: 2, tab: 'Timeline', url:'timeline' }, { id: 3, tab: 'Networks', url:'networks' }, { id: 5, tab: 'Review', url:'review' }, { id: 6, tab: 'Setting', url:'settings' }, 
    ];
  } else if (list === "Years") {
    const startYear = new Date().getFullYear();
    for (let i = startYear; i > startYear - 40; i--) {
      listObj.push({ id: i, year: i });
    }
  } else if (list === "Interest") {
    listObj = [
      { id: 1, name: "Personal Services" }, { id: 1, name: "Business Services" }, { id: 1, name: "Marketing and Sales" }, { id: 1, name: "Computers and Technology" }, { id: 1, name: "Children`s Services" }, { id: 1, name: "Event Services" }, { id: 1, name: "Business & Legal Services" }, { id: 1, name: "Education" }, { id: 1, name: "Energy" }, { id: 1, name: "Environment & Weather" }, { id: 1, name: "Finance & Investment" }, { id: 1, name: "Geo-spatial/Mapping" }, { id: 1, name: "Governance" }, { id: 1, name: "Healthcare" }, { id: 1, name: "Housing & Real Estate" }, { id: 1, name: "Insurance" }, { id: 1, name: "Lifestyle & Consumer" }, { id: 1, name: "Media" }, { id: 1, name: "Research & Consulting" }, { id: 1, name: "Scientific Research" }, { id: 1, name: "Agriculture & Food" }, { id: 1, name: "Chemicals, Pharmaceuticals & Plastics" }, { id: 1, name: "Construction" }, { id: 1, name: "Energy, Environment" }, { id: 1, name: "Education, Training & Organisations" }, { id: 1, name: "Leisure & Tourism" }, { id: 1, name: "Electrical, Electronics & Optical" }, { id: 1, name: "Metals, Machinery & Engineering" }, { id: 1, name: "Retail & Traders" }, { id: 1, name: "Paper, Printing, Publishing" }, { id: 1, name: "Minerals" }, { id: 1, name: "Textiles, Clothing, Leather, Watchmaking, Jewellery" }, { id: 1, name: "Transport & Logistics" }
    ];
  } else if(list === "DialCodes"){
    listObj = [
      {"name":"Afghanistan","dial_code":"+93","code":"AF"},{"name":"Albania","dial_code":"+355","code":"AL"},
      {"name":"Algeria","dial_code":"+213","code":"DZ"},{"name":"AmericanSamoa","dial_code":"+1 684","code":"AS"},
      {"name":"Andorra","dial_code":"+376","code":"AD"},{"name":"Angola","dial_code":"+244","code":"AO"},
      {"name":"Anguilla","dial_code":"+1 264","code":"AI"},{"name":"Antarctica","dial_code":"+672","code":"AQ"},
      {"name":"Antigua and Barbuda","dial_code":"+1268","code":"AG"},{"name":"Argentina","dial_code":"+54","code":"AR"},
      {"name":"Armenia","dial_code":"+374","code":"AM"},{"name":"Aruba","dial_code":"+297","code":"AW"},
      {"name":"Australia","dial_code":"+61","code":"AU"},{"name":"Austria","dial_code":"+43","code":"AT"},
      {"name":"Azerbaijan","dial_code":"+994","code":"AZ"},{"name":"Bahamas","dial_code":"+1 242","code":"BS"},
      {"name":"Bahrain","dial_code":"+973","code":"BH"},{"name":"Bangladesh","dial_code":"+880","code":"BD"},{"name":"Barbados","dial_code":"+1 246","code":"BB"},{"name":"Belarus","dial_code":"+375","code":"BY"},{"name":"Belgium","dial_code":"+32","code":"BE"},{"name":"Belize","dial_code":"+501","code":"BZ"},{"name":"Benin","dial_code":"+229","code":"BJ"},{"name":"Bermuda","dial_code":"+1 441","code":"BM"},{"name":"Bhutan","dial_code":"+975","code":"BT"},{"name":"Bolivia, Plurinational State of","dial_code":"+591","code":"BO"},{"name":"Bosnia and Herzegovina","dial_code":"+387","code":"BA"},{"name":"Botswana","dial_code":"+267","code":"BW"},{"name":"Brazil","dial_code":"+55","code":"BR"},{"name":"British Indian Ocean Territory","dial_code":"+246","code":"IO"},{"name":"Brunei Darussalam","dial_code":"+673","code":"BN"},{"name":"Bulgaria","dial_code":"+359","code":"BG"},{"name":"Burkina Faso","dial_code":"+226","code":"BF"},{"name":"Burundi","dial_code":"+257","code":"BI"},{"name":"Cambodia","dial_code":"+855","code":"KH"},{"name":"Cameroon","dial_code":"+237","code":"CM"},{"name":"Canada","dial_code":"+1","code":"CA"},{"name":"Cape Verde","dial_code":"+238","code":"CV"},{"name":"Cayman Islands","dial_code":"+ 345","code":"KY"},{"name":"Central African Republic","dial_code":"+236","code":"CF"},{"name":"Chad","dial_code":"+235","code":"TD"},{"name":"Chile","dial_code":"+56","code":"CL"},{"name":"China","dial_code":"+86","code":"CN"},{"name":"Christmas Island","dial_code":"+61","code":"CX"},{"name":"Cocos (Keeling) Islands","dial_code":"+61","code":"CC"},{"name":"Colombia","dial_code":"+57","code":"CO"},{"name":"Comoros","dial_code":"+269","code":"KM"},{"name":"Congo","dial_code":"+242","code":"CG"},{"name":"Congo, The Democratic Republic of the","dial_code":"+243","code":"CD"},{"name":"Cook Islands","dial_code":"+682","code":"CK"},{"name":"Costa Rica","dial_code":"+506","code":"CR"},{"name":"Cote d'Ivoire","dial_code":"+225","code":"CI"},{"name":"Croatia","dial_code":"+385","code":"HR"},{"name":"Cuba","dial_code":"+53","code":"CU"},{"name":"Cyprus","dial_code":"+537","code":"CY"},{"name":"Czech Republic","dial_code":"+420","code":"CZ"},{"name":"Denmark","dial_code":"+45","code":"DK"},{"name":"Djibouti","dial_code":"+253","code":"DJ"},{"name":"Dominica","dial_code":"+1 767","code":"DM"},{"name":"Dominican Republic","dial_code":"+1 849","code":"DO"},{"name":"Ecuador","dial_code":"+593","code":"EC"},{"name":"Egypt","dial_code":"+20","code":"EG"},{"name":"El Salvador","dial_code":"+503","code":"SV"},{"name":"Equatorial Guinea","dial_code":"+240","code":"GQ"},{"name":"Eritrea","dial_code":"+291","code":"ER"},{"name":"Estonia","dial_code":"+372","code":"EE"},{"name":"Ethiopia","dial_code":"+251","code":"ET"},{"name":"Falkland Islands (Malvinas)","dial_code":"+500","code":"FK"},{"name":"Faroe Islands","dial_code":"+298","code":"FO"},{"name":"Fiji","dial_code":"+679","code":"FJ"},{"name":"Finland","dial_code":"+358","code":"FI"},{"name":"France","dial_code":"+33","code":"FR"},{"name":"French Guiana","dial_code":"+594","code":"GF"},{"name":"French Polynesia","dial_code":"+689","code":"PF"},{"name":"Gabon","dial_code":"+241","code":"GA"},{"name":"Gambia","dial_code":"+220","code":"GM"},{"name":"Georgia","dial_code":"+995","code":"GE"},{"name":"Germany","dial_code":"+49","code":"DE"},{"name":"Ghana","dial_code":"+233","code":"GH"},{"name":"Gibraltar","dial_code":"+350","code":"GI"},{"name":"Greece","dial_code":"+30","code":"GR"},{"name":"Greenland","dial_code":"+299","code":"GL"},{"name":"Grenada","dial_code":"+1 473","code":"GD"},{"name":"Guadeloupe","dial_code":"+590","code":"GP"},{"name":"Guam","dial_code":"+1 671","code":"GU"},{"name":"Guatemala","dial_code":"+502","code":"GT"},{"name":"Guernsey","dial_code":"+44","code":"GG"},{"name":"Guinea","dial_code":"+224","code":"GN"},{"name":"Guinea-Bissau","dial_code":"+245","code":"GW"},{"name":"Guyana","dial_code":"+595","code":"GY"},{"name":"Haiti","dial_code":"+509","code":"HT"},{"name":"Holy See (Vatican City State)","dial_code":"+379","code":"VA"},{"name":"Honduras","dial_code":"+504","code":"HN"},{"name":"Hong Kong","dial_code":"+852","code":"HK"},{"name":"Hungary","dial_code":"+36","code":"HU"},{"name":"Iceland","dial_code":"+354","code":"IS"},
      {"name":"India","dial_code":"+91","code":"IN"},{"name":"Indonesia","dial_code":"+62","code":"ID"},{"name":"Iran, Islamic Republic of","dial_code":"+98","code":"IR"},{"name":"Iraq","dial_code":"+964","code":"IQ"},{"name":"Ireland","dial_code":"+353","code":"IE"},{"name":"Isle of Man","dial_code":"+44","code":"IM"},{"name":"Israel","dial_code":"+972","code":"IL"},{"name":"Italy","dial_code":"+39","code":"IT"},{"name":"Jamaica","dial_code":"+1 876","code":"JM"},{"name":"Japan","dial_code":"+81","code":"JP"},{"name":"Jersey","dial_code":"+44","code":"JE"},{"name":"Jordan","dial_code":"+962","code":"JO"},{"name":"Kazakhstan","dial_code":"+7 7","code":"KZ"},{"name":"Kenya","dial_code":"+254","code":"KE"},{"name":"Kiribati","dial_code":"+686","code":"KI"},{"name":"Korea, Democratic People's Republic of","dial_code":"+850","code":"KP"},{"name":"Korea, Republic of","dial_code":"+82","code":"KR"},{"name":"Kuwait","dial_code":"+965","code":"KW"},{"name":"Kyrgyzstan","dial_code":"+996","code":"KG"},{"name":"Lao People's Democratic Republic","dial_code":"+856","code":"LA"},{"name":"Latvia","dial_code":"+371","code":"LV"},{"name":"Lebanon","dial_code":"+961","code":"LB"},{"name":"Lesotho","dial_code":"+266","code":"LS"},{"name":"Liberia","dial_code":"+231","code":"LR"},{"name":"Libyan Arab Jamahiriya","dial_code":"+218","code":"LY"},{"name":"Liechtenstein","dial_code":"+423","code":"LI"},{"name":"Lithuania","dial_code":"+370","code":"LT"},{"name":"Luxembourg","dial_code":"+352","code":"LU"},{"name":"Macao","dial_code":"+853","code":"MO"},{"name":"Macedonia, The Former Yugoslav Republic of","dial_code":"+389","code":"MK"},{"name":"Madagascar","dial_code":"+261","code":"MG"},{"name":"Malawi","dial_code":"+265","code":"MW"},{"name":"Malaysia","dial_code":"+60","code":"MY"},{"name":"Maldives","dial_code":"+960","code":"MV"},{"name":"Mali","dial_code":"+223","code":"ML"},{"name":"Malta","dial_code":"+356","code":"MT"},{"name":"Marshall Islands","dial_code":"+692","code":"MH"},{"name":"Martinique","dial_code":"+596","code":"MQ"},{"name":"Mauritania","dial_code":"+222","code":"MR"},{"name":"Mauritius","dial_code":"+230","code":"MU"},{"name":"Mayotte","dial_code":"+262","code":"YT"},{"name":"Mexico","dial_code":"+52","code":"MX"},{"name":"Micronesia, Federated States of","dial_code":"+691","code":"FM"},{"name":"Moldova, Republic of","dial_code":"+373","code":"MD"},{"name":"Monaco","dial_code":"+377","code":"MC"},{"name":"Mongolia","dial_code":"+976","code":"MN"},{"name":"Montenegro","dial_code":"+382","code":"ME"},{"name":"Montserrat","dial_code":"+1664","code":"MS"},{"name":"Morocco","dial_code":"+212","code":"MA"},{"name":"Mozambique","dial_code":"+258","code":"MZ"},{"name":"Myanmar","dial_code":"+95","code":"MM"},{"name":"Namibia","dial_code":"+264","code":"NA"},{"name":"Nauru","dial_code":"+674","code":"NR"},{"name":"Nepal","dial_code":"+977","code":"NP"},{"name":"Netherlands","dial_code":"+31","code":"NL"},{"name":"Netherlands Antilles","dial_code":"+599","code":"AN"},{"name":"New Caledonia","dial_code":"+687","code":"NC"},{"name":"New Zealand","dial_code":"+64","code":"NZ"},{"name":"Nicaragua","dial_code":"+505","code":"NI"},{"name":"Niger","dial_code":"+227","code":"NE"},{"name":"Nigeria","dial_code":"+234","code":"NG"},{"name":"Niue","dial_code":"+683","code":"NU"},{"name":"Norfolk Island","dial_code":"+672","code":"NF"},{"name":"Northern Mariana Islands","dial_code":"+1 670","code":"MP"},{"name":"Norway","dial_code":"+47","code":"NO"},{"name":"Oman","dial_code":"+968","code":"OM"},{"name":"Pakistan","dial_code":"+92","code":"PK"},{"name":"Palau","dial_code":"+680","code":"PW"},{"name":"Palestinian Territory, Occupied","dial_code":"+970","code":"PS"},{"name":"Panama","dial_code":"+507","code":"PA"},{"name":"Papua New Guinea","dial_code":"+675","code":"PG"},{"name":"Paraguay","dial_code":"+595","code":"PY"},{"name":"Peru","dial_code":"+51","code":"PE"},{"name":"Philippines","dial_code":"+63","code":"PH"},{"name":"Pitcairn","dial_code":"+872","code":"PN"},{"name":"Poland","dial_code":"+48","code":"PL"},{"name":"Portugal","dial_code":"+351","code":"PT"},{"name":"Puerto Rico","dial_code":"+1 939","code":"PR"},{"name":"Qatar","dial_code":"+974","code":"QA"},{"name":"Romania","dial_code":"+40","code":"RO"},{"name":"Russia","dial_code":"+7","code":"RU"},{"name":"Rwanda","dial_code":"+250","code":"RW"},{"name":"Réunion","dial_code":"+262","code":"RE"},{"name":"Saint Barthélemy","dial_code":"+590","code":"BL"},{"name":"Saint Helena, Ascension and Tristan Da Cunha","dial_code":"+290","code":"SH"},{"name":"Saint Kitts and Nevis","dial_code":"+1 869","code":"KN"},{"name":"Saint Lucia","dial_code":"+1 758","code":"LC"},{"name":"Saint Martin","dial_code":"+590","code":"MF"},
      {"name":"Saint Pierre and Miquelon","dial_code":"+508","code":"PM"},{"name":"Saint Vincent and the Grenadines","dial_code":"+1 784","code":"VC"},
      {"name":"Samoa","dial_code":"+685","code":"WS"},{"name":"San Marino","dial_code":"+378","code":"SM"},{"name":"Sao Tome and Principe","dial_code":"+239","code":"ST"},{"name":"Saudi Arabia","dial_code":"+966","code":"SA"},{"name":"Senegal","dial_code":"+221","code":"SN"},{"name":"Serbia","dial_code":"+381","code":"RS"},{"name":"Seychelles","dial_code":"+248","code":"SC"},{"name":"Sierra Leone","dial_code":"+232","code":"SL"},{"name":"Singapore","dial_code":"+65","code":"SG"},{"name":"Slovakia","dial_code":"+421","code":"SK"},{"name":"Slovenia","dial_code":"+386","code":"SI"},{"name":"Solomon Islands","dial_code":"+677","code":"SB"},{"name":"Somalia","dial_code":"+252","code":"SO"},{"name":"South Africa","dial_code":"+27","code":"ZA"},{"name":"South Georgia and the South Sandwich Islands","dial_code":"+500","code":"GS"},{"name":"Spain","dial_code":"+34","code":"ES"},{"name":"Sri Lanka","dial_code":"+94","code":"LK"},{"name":"Sudan","dial_code":"+249","code":"SD"},{"name":"Suriname","dial_code":"+597","code":"SR"},{"name":"Svalbard and Jan Mayen","dial_code":"+47","code":"SJ"},{"name":"Swaziland","dial_code":"+268","code":"SZ"},{"name":"Sweden","dial_code":"+46","code":"SE"},{"name":"Switzerland","dial_code":"+41","code":"CH"},{"name":"Syrian Arab Republic","dial_code":"+963","code":"SY"},{"name":"Taiwan, Province of China","dial_code":"+886","code":"TW"},{"name":"Tajikistan","dial_code":"+992","code":"TJ"},{"name":"Tanzania, United Republic of","dial_code":"+255","code":"TZ"},{"name":"Thailand","dial_code":"+66","code":"TH"},{"name":"Timor-Leste","dial_code":"+670","code":"TL"},{"name":"Togo","dial_code":"+228","code":"TG"},{"name":"Tokelau","dial_code":"+690","code":"TK"},{"name":"Tonga","dial_code":"+676","code":"TO"},{"name":"Trinidad and Tobago","dial_code":"+1 868","code":"TT"},{"name":"Tunisia","dial_code":"+216","code":"TN"},{"name":"Turkey","dial_code":"+90","code":"TR"},{"name":"Turkmenistan","dial_code":"+993","code":"TM"},{"name":"Turks and Caicos Islands","dial_code":"+1 649","code":"TC"},{"name":"Tuvalu","dial_code":"+688","code":"TV"},{"name":"Uganda","dial_code":"+256","code":"UG"},{"name":"Ukraine","dial_code":"+380","code":"UA"},{"name":"United Arab Emirates","dial_code":"+971","code":"AE"},{"name":"United Kingdom","dial_code":"+44","code":"GB"},{"name":"United States","dial_code":"+1","code":"US"},{"name":"Uruguay","dial_code":"+598","code":"UY"},{"name":"Uzbekistan","dial_code":"+998","code":"UZ"},{"name":"Vanuatu","dial_code":"+678","code":"VU"},{"name":"Venezuela, Bolivarian Republic of","dial_code":"+58","code":"VE"},{"name":"Viet Nam","dial_code":"+84","code":"VN"},{"name":"Virgin Islands, British","dial_code":"+1 284","code":"VG"},{"name":"Virgin Islands, U.S.","dial_code":"+1 340","code":"VI"},{"name":"Wallis and Futuna","dial_code":"+681","code":"WF"},{"name":"Yemen","dial_code":"+967","code":"YE"},{"name":"Zambia","dial_code":"+260","code":"ZM"},{"name":"Zimbabwe","dial_code":"+263","code":"ZW"},{"name":"Åland Islands","dial_code":"+358","code":"AX"}
    ];   
  }
  return listObj;
}

function getLocationObj(result){
  const addressObj = {
    "route": "",
    "political": "",
    "locality": "",
    "administrative_area_level_2": "",
    "administrative_area_level_1": "",
    "postal_code": "",
    "country": "",
    "political": "",
   }
  const addressComponents = result.address_components;
  addressComponents.map(function(v,k){
    let types = v.types;
    if(types.length>0){
      if(types[0]==="route"){
        addressObj.route = v.long_name;
      } else if(types[0]==="political"){
        addressObj.political = v.long_name;
      } else if(types[0]==="locality"){
        addressObj.locality = v.long_name;
      } else if(types[0]==="administrative_area_level_2"){
        addressObj.administrative_area_level_2 = v.long_name;
      } else if(types[0]==="administrative_area_level_1"){
        addressObj.administrative_area_level_1 = v.long_name;
      } else if(types[0]==="postal_code"){
        addressObj.postal_code = v.long_name;
      } else if(types[0]==="country"){
        addressObj.country = v.long_name;
      }
    }
  });
  return addressObj;
}

function videoThumbnail(file){ 
  var vid = document.createElement('video');
  vid.src = window.URL.createObjectURL(file);
  var canvas = document.createElement('canvas');
  canvas.width  = 105;
  canvas.height = 100;
  canvas.getContext("2d").drawImage(vid, 0, 0, 100, 100);
  window.URL.revokeObjectURL(file);                
  return window.URL.createObjectURL(file);
}

function existInArray(val,arr=null){
  if(arr===null) return false;

  const index = arr.indexOf(val);
  if(index>=0) return true

  return false
}

async function setDefaultCompany(company_id,is_id='other'){
  if(is_id==='user_company'){
    await localStorage.setItem('COMPANY_ID', company_id);
    await localStorage.setItem('SELECTED_COMPANY_ID', company_id);
    await localStorage.setItem('OTHER_COMPANY_ID', '');
  } else {
    await localStorage.setItem('COMPANY_ID', '');
    await localStorage.setItem('OTHER_COMPANY_ID', company_id);
  }
  return true;
}

function getDefaultCompanyId(){
  const companyId = localStorage.getItem('SELECTED_COMPANY_ID',);
  if(companyId!=='' && companyId!==null && companyId!==undefined){
      return companyId;
  } else {
    return '';
  }
}
function isSelfCompanyId(userData){
  // const ownCompanyId =  localStorage.getItem('SELECTED_COMPANY_ID');
  const ownCompanyId =  localStorage.getItem('COMPANY_ID');
  if(ownCompanyId==='' || ownCompanyId===null || ownCompanyId===undefined){
    return false;
  }

  const { account_id, company_profiles } = userData.data
  const companyId =  localStorage.getItem('OTHER_COMPANY_ID');
  if(company_profiles!==null && company_profiles!==undefined ){
    if(company_profiles.length>0){
        if(companyId!==null && companyId!==undefined && companyId!==''){
          const index = company_profiles.indexOf(companyId);
          if(index=== -1) return false
        }
    }
  }
  return true;
}
function getCompanyInfo(companyDetails,key){
  const companyData = getCompanyDetailsObj(companyDetails)
  switch(key) {
    case 'company_id':
      return companyData.company_id;    
    case 'company_name':
      return companyData.company_name;
    case 'creation_ts':
      return companyData.creation_ts;
    case 'company_info_id':
      return companyData.info_id;
    case 'followers':
      return companyData.totalFollowers;
    case 'followings':
      return companyData.totalFollowing;
    case 'website_url':
      return companyData.website_url;
    case 'mobile_number':
      return companyData.mobile_number;
    case 'company_email':
      return companyData.company_email;
    case 'company_logo':
      return companyData.company_logo;
    case 'cover_img':
      return companyData.cover_image;
    default:
      return '';
  }
  
}
function getCompanyDetailsObj(companyData,type='own',key=null){
  const obj = {
    id: "",
    account_id: "",
    company_name: "",
    company_sub_title: "",
    company_type: "",
    description: "",
    creation_ts: 0,
    modified_ts: 0,
    totalFollowers: 0,
    totalFollowing: 0,
    follow_status: "", //0=unfollow 1=follow
    is_connected: "",
    is_blocked:"",
    is_poked: "",
    follow_id:"",
    connection_id:"",

    info_id: "",
    company_id: "",
    location: {address: "", city: "", state: "", country: "", postal_code: "", longitude: "", latitude: ""},
    location: "",
    website_url: "",
    mobile_number: "",
    mobile_with_code: "",
    mobile_country_code: "",
    is_mobile_verified: "",
    company_email: "",
    is_email_verified: "",
    year_founded: "",
    industry_type: "",
    company_size: "",
    about_company: "",
    specialization: "",
    privacy: "",
    creation_ts: 0,
    modified_ts: 0,
    founder: "",
    team: "",
    fax_number: "",
    company_profile_url: "",
    company_logo: Constants.defaultImageUrls.companyLogo,
    cover_image: Constants.defaultImageUrls.companyCover,
  }
  if(companyData===null){
    return obj;
  }
  if(companyData===undefined){
    return obj;
  }
  if(objLength(companyData)===0){
    return obj;
  }
  if(companyData.data===undefined){
    return obj;
  }
  if(objLength(companyData.data)>0){
    if(companyData.data.Field_Visibility!==undefined && companyData.data!==null){
      return obj;
    }
  }

  const { companyInfo, company, totalFollowers, totalFollowing, follow_status, is_connected, is_blocked, is_poked, follow_id, connection_id} = companyData.data
  let cInfo = null;
  if(companyInfo!==undefined){
    if(companyInfo.length>0){
      if(companyInfo[0]!==null || companyInfo[0]!==undefined){
        cInfo = companyInfo[0];
      }
    }
  }

  if(company!==undefined && company!==null){
    if(company.id!==undefined && company.id!==null) obj.id = company.id;
    if(company.id!==undefined && company.id!==null) obj.company_id = company.id;
    if(company.account_id!==undefined && company.account_id!==null) obj.account_id = company.account_id;
    if(company.company_name!==undefined && company.company_name!==null) obj.company_name = company.company_name;
    if(company.company_sub_title!==undefined && company.company_sub_title!==null) obj.company_sub_title = company.company_sub_title;
    if(company.company_type!==undefined && company.company_type!==null) obj.company_type = company.company_type;
    if(company.description!==undefined && company.description!==null) obj.description = company.description;
    if(company.creation_ts!==undefined && company.creation_ts!==null){
       const date = getDateObj(company.creation_ts);
       obj.creation_ts = date.dayNum+'-'+date.monthShort+'-'+date.fullYear;
    }
    //if(company.modified_ts!==undefined && company.modified_ts!==null) obj.modified_ts = company.modified_ts;
    if(company.company_logo!==undefined && company.company_logo!==null) obj.company_logo = process.env.REACT_APP_BUCKET_PATH+'/'+company.company_logo.image_path;
  }
  if(cInfo!==null){
    if(cInfo.id!==undefined && cInfo.id!==null) obj.info_id = cInfo.id;
    if(cInfo.website_url!==undefined && cInfo.website_url!==null) obj.website_url = cInfo.website_url;
    if(cInfo.mobile_number!==undefined && cInfo.mobile_number!==null) obj.mobile_number = cInfo.mobile_number;
    if(cInfo.mobile_country_code!==undefined && cInfo.mobile_country_code!==null) obj.mobile_country_code = cInfo.mobile_country_code;
    if(cInfo.is_mobile_verified!==undefined && cInfo.is_mobile_verified!==null) obj.is_mobile_verified = cInfo.is_mobile_verified;
    if(cInfo.company_email!==undefined && cInfo.company_email!==null) obj.company_email = cInfo.company_email;
    if(cInfo.is_email_verified!==undefined && cInfo.is_email_verified!==null) obj.is_email_verified = cInfo.is_email_verified;
    if(cInfo.year_founded!==undefined && cInfo.year_founded!==null) obj.year_founded = cInfo.year_founded;
    if(cInfo.industry_type!==undefined && cInfo.industry_type!==null) obj.industry_type = cInfo.industry_type;
    if(cInfo.company_size!==undefined && cInfo.company_size!==null) obj.company_size = cInfo.company_size;
    if(cInfo.about_company!==undefined && cInfo.about_company!==null) obj.about_company = cInfo.about_company;
    if(cInfo.specialization!==undefined && cInfo.specialization!==null) obj.specialization = cInfo.specialization;
    if(cInfo.location!==undefined && cInfo.location!==null) obj.location = cInfo.location;
    if(cInfo.privacy!==undefined && cInfo.privacy!==null) obj.privacy = cInfo.privacy;
    if(cInfo.founder!==undefined && cInfo.founder!==null) obj.founder = cInfo.founder;
    if(cInfo.team!==undefined && cInfo.team!==null) obj.team = cInfo.team;
    if(cInfo.fax_number!==undefined && cInfo.fax_number!==null) obj.fax_number = cInfo.fax_number;
    //if(cInfo.company_profile_url!==undefined && cInfo.company_profile_url!==null) obj.company_profile_url = cInfo.company_profile_url;
    if(cInfo.cover_image!==undefined && cInfo.cover_image!==null) obj.cover_image = process.env.REACT_APP_BUCKET_PATH+'/'+cInfo.cover_image.image_path;
    
    if(cInfo.mobile_number!==undefined && cInfo.mobile_number!==null){
      if(cInfo.mobile_country_code!==undefined && cInfo.mobile_country_code!==null){
        obj.mobile_with_code = cInfo.mobile_country_code+'-'+cInfo.mobile_number;
      }
    } 
  }
    
  if(totalFollowers!==undefined && totalFollowers!==null) obj.totalFollowers = totalFollowers;
  if(totalFollowing!==undefined && totalFollowing!==null) obj.totalFollowing = totalFollowing;
  if(follow_status!==undefined && follow_status!==null) obj.follow_status = follow_status;
  if(is_connected!==undefined && is_connected!==null) obj.is_connected = is_connected;
  if(is_blocked!==undefined && is_blocked!==null) obj.is_blocked = is_blocked;
  if(is_poked!==undefined && is_poked!==null) obj.is_poked = is_poked;
  if(follow_id!==undefined && follow_id!==null) obj.follow_id = follow_id;
  if(connection_id!==undefined && connection_id!==null) obj.connection_id = connection_id;
  return obj;
}
function checkValExist(val){
  if(val!==undefined && val!==null && val!==''){
    return val;
  }
  return '';
}
function setReviewCounter(reviewData){
  localStorage.setItem('REVIEW_COUNT',0);
  if(reviewData!==null && reviewData!==undefined){
    if(reviewData.data!==undefined && reviewData.data!==null){
        if(reviewData.data.reviews!==null && reviewData.data.reviews!==undefined){
          localStorage.setItem('REVIEW_COUNT',reviewData.data.reviews.length);

        }
    }
  }
}
function ordinalSuffix(i) {
  let j = i % 10;
  let k = i % 100;
  if (j == 1 && k != 11) return i + "st";
  if (j == 2 && k != 12) return i + "nd";
  if (j == 3 && k != 13) return i + "rd";
  return i + "th";
}
export default {
  googleApiKey,
  expandedLine,
  fetchSize,
  convertDate,
  objLength,
  secondsToTime,
  getCurrentTS,
  timeSince,
  getDateObj,
  flashMsg,
  chkVal,
  getDropdownsVals,
  getLocationObj,
  videoThumbnail,
  existInArray,
  setDefaultCompany,
  getDefaultCompanyId,
  getCompanyInfo,
  getCompanyDetailsObj,
  fileSizesObj,
  isSelfCompanyId,
  setReviewCounter,
  ordinalSuffix
};
